"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlushStyles = void 0;
var _react = require("react");
var _isRtl = require("../utils/isRtl");
const useFlushStyles = ({
  flush,
  spacing
}) => {
  let offsetDirection = flush === 'start' ? 'left' : 'right';
  // We need to invert the setup for RTL
  if ((0, _isRtl.isRtl)()) {
    offsetDirection = flush === 'start' ? 'right' : 'left';
  }
  const style = (0, _react.useMemo)(() => ({
    marginLeft: offsetDirection === 'left' ? `calc(var(--spacing-${spacing.start}) * -1)` : 0,
    marginRight: offsetDirection === 'right' ? `calc(var(--spacing-${spacing.end}) * -1)` : 0,
    minWidth: 'unset'
  }), [offsetDirection, spacing]);
  return flush ? style : null;
};
exports.useFlushStyles = useFlushStyles;